import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { DirectoryRecord } from "@/shared/domain/files";

import * as GetDirectoryContents from "./useDirectoryContents";
import * as GetDirectoryItemCount from "./useDirectoryItemCount";

interface CreateDirectoryProps {
  datasetId: string;
  directoryName: string;
  parentPath: string | null;
}

export function useCreateDirectoryMutation() {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<DirectoryRecord, Error, CreateDirectoryProps>({
    mutationFn: ({ datasetId, directoryName, parentPath }) => {
      return fileService.createDirectory(datasetId, directoryName, parentPath);
    },
    onSuccess: () => {
      // invalidate the page count
      const countPromise = queryClient.invalidateQueries({
        queryKey: GetDirectoryItemCount.getQueryKey(),
        exact: false,
      });

      // invalidate the page contents
      const contentsPromise = queryClient.invalidateQueries({
        queryKey: GetDirectoryContents.getQueryKey(),
        exact: false,
      });

      return Promise.all([countPromise, contentsPromise]);
    },
  });
}
